<template>
  <div class="custom-input">
    <form class="input-content" @submit.prevent="handleSearch">
      <i class="iconfont icon-icon-fangdajing iconfont" style="color: #98a3b7;font-size:16px"></i>
      <el-input
        v-model.trim="modelValue"
        placeholder="搜索询盘编号、采购商、零件名称、询盘标题、报价编号"
        clearable
        @keyup.enter="handleSearch"
      ></el-input>
      <p class="custom-search-button" @click="handleSearch" >搜索</p>
    </form>
  </div>
</template>

<script>
export default {
  name: 'custom-input',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    handleSearch() {
      this.$emit('handleSearch')
    },
  },
  mounted() {
    //
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>

<style scoped lang="scss">
/* SCSS or CSS here */
.custom-input {
  width: 540px;
  border-radius: 999px;
  border: 1px solid #0863ff;
  background-color: #fff;
  ::v-deep .el-input--small .el-input__inner {
    border: none;
    outline: none;
    padding-left: 8px;
  }
  ::v-deep .el-input__inner::placeholder {
    color: #98a3b7;
  }
  ::v-deep .el-input__inner {
    font-size: 16px;
    line-height: 33px;
  }
  .input-content {
    margin-left: 16px;
    margin-right: 4px;
    margin-top: 4px;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .custom-search-button {
      padding: 5px 16px;
      justify-content: center;
      align-items: center;
      border-radius: 999px;
      background: #0863ff;
      color: #ffffff;
      font-family: 'Source Han Sans CN';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      flex-shrink: 0;
      cursor: pointer;
    }
  }
}
</style>
